import { Fragment, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import Swal from "sweetalert2";
import { getMethod, postRequestByAuth } from "../../../function/helper";
import validateFormatNationalCode from "../../../function/validateFormatNationalCode";
import style from "./NewAddress.module.css";
import CompanyValidateModal from "./components/CompanyValidateModal";

function NewAddress({ senderOrgetter, url, onClose, setResult }) {
  if (!url) {
    url = "/address/v1/addAddress";
  }

  const {
    register,
    handleSubmit,
    unregister,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const [personType, setPersonType] = useState(0);
  const [cities, setCities] = useState([{ value: 0, label: "..." }]);
  const [provinces, setProvinces] = useState([]);
  const [areas, setAreas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyValidateModal, setCompanyValidateModal] = useState(false);
  const [companiesValidation, setCompaniesValidation] = useState({});
  const [finalData, setFinalData] = useState({});
  const [isForeignNationalCode, setForeignNationalCode] = useState(false);

  const sendAddress = async (data, setResult) => {
    const response = await postRequestByAuth(url, data);
    setIsLoading(() => false);

    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        text: "ثبت آدرس با موفقیت انجام شد",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
      });
      setResult(response.data.data);
    } else {
      Swal.fire({
        icon: "error",
        text: response?.data?.data ?? "خطای ارتباط با سرور",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
      });
      setCompanyValidateModal(false);
    }
  };

  const doSubmit = async values => {
    const data = {
      ...values,
      nationalCode:
        values.type === 0 ? values.nationalCode : values.companyCode,
      Default: 0,
      countryId: 1,
    };

    setIsLoading(() => true);
    setFinalData(() => data);

    if (data.senderOrgetter === 1) {
      const validateCity = await getMethod(
        "/address/v1/city/company-validate?cityId=" + data.cityId
      );

      if (validateCity && validateCity.status === 200) {
        if (
          validateCity.result.post === false ||
          validateCity.result.chapar === false ||
          validateCity.result.mahex === false ||
          validateCity.result.tipax === false
        ) {
          setCompaniesValidation(() => validateCity.result);
          setCompanyValidateModal(() => true);
          return;
        }
      }
    }

    sendAddress(data, setResult);
  };

  const getCities = async id => {
    setLoading(() => true);
    const response = await getMethod("/address/v1/city/show/" + id);
    setLoading(() => false);

    const cityArray = [{ value: 0, label: "..." }];
    if (response.data) {
      response.data.forEach(item =>
        cityArray.push({ value: item.id, label: item.faName })
      );
    }
    setCities(() => cityArray);
  };

  const getArea = async id => {
    setLoading(() => true);
    const response = await getMethod(
      `/address/v1/area/all/1/200?provinceId=0&cityId=${id}`
    );
    setLoading(() => false);

    if (response) {
      if (response.data) {
        setAreas(() => response.data.area);
      }
    }
  };

  const getProvince = async () => {
    setLoading(() => true);
    const response = await getMethod("/address/v1/province/show/1");
    setLoading(() => false);

    if (response.data) {
      setProvinces(() => response.data);
    }
  };

  useEffect(() => {
    getProvince();
  }, []);

  useEffect(() => {
    if (personType === 0) {
      unregister("compony");
      unregister("companyCode");
    } else {
      unregister("name");
      unregister("family");
    }
  }, [personType]);

  return (
    <Fragment>
      {companyValidateModal && (
        <CompanyValidateModal
          close={() => {
            setCompanyValidateModal(() => false);
            setIsLoading(() => false);
          }}
          submit={() => sendAddress(finalData, setResult)}
          companiesValidation={companiesValidation}
        />
      )}

      <Modal
        show={true}
        size="lg"
        centered={true}
        className={style.modal}
        onHide={() => onClose(-1)}
      >
        <form>
          <Modal.Header className="bg-white">
            <h5 className="m-0">ثبت آدرس جدید</h5>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <div className="d-flex flex-wrap align-items-start">
              <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                <Form.Label>نوع آدرس</Form.Label>
                <Form.Select
                  disabled={typeof senderOrgetter === "number"}
                  {...register("senderOrgetter", {
                    value: senderOrgetter,
                    valueAsNumber: true,
                  })}
                >
                  <option value={0}>فرستنده</option>
                  <option value={1}>گیرنده</option>
                </Form.Select>
              </Col>

              <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                <Form.Label>نوع شخص</Form.Label>
                <Form.Select
                  {...register("type", {
                    valueAsNumber: true,
                    onChange: e =>
                      setPersonType(() => parseInt(e.target.value)),
                  })}
                >
                  <option value={0}>حقیقی</option>
                  <option value={1}>حقوقی</option>
                </Form.Select>
              </Col>

              {personType === 0 && (
                <Fragment>
                  <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                    <Form.Label>
                      نام
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      {...register("name", {
                        required: true,
                        minLength: 3,
                        maxLength: 50,
                      })}
                    />
                    {errors.name?.type === "required" && <p>نام الزامی</p>}
                    {errors.name?.type === "minLength" && (
                      <p>حداقل 3 کاراکتر</p>
                    )}
                    {errors.name?.type === "maxLength" && (
                      <p>حداکثر 50 کاراکتر</p>
                    )}
                  </Col>

                  <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                    <Form.Label>
                      نام خانوادگی
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      {...register("family", { required: true })}
                    />
                    {errors.family?.type === "required" && (
                      <p>نام خانوادگی الزامی</p>
                    )}
                  </Col>

                  <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                    <Form.Label>
                      کد ملی
                      {senderOrgetter === 0 && !isForeignNationalCode && (
                        <span className="text-danger">*</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      {...register("nationalCode", {
                        required: {
                          value: senderOrgetter === 0 && !isForeignNationalCode,
                          message: "کد ملی الزامی",
                        },
                        validate: {
                          length: v => {
                            if (!v) {
                              return true;
                            }
                            if (v.length === 10) {
                              return true;
                            }
                            return "کد ملی باید 10 رقم باشد";
                          },

                          format: v => {
                            if (!v) {
                              return true;
                            }
                            if (validateFormatNationalCode(v)) {
                              return true;
                            }
                            return "فرمت کد ملی صحیح نمی‌باشد";
                          },
                        },
                      })}
                    />
                    {errors.nationalCode && (
                      <p>{errors.nationalCode.message}</p>
                    )}
                  </Col>
                </Fragment>
              )}

              {personType === 1 && (
                <Fragment>
                  <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                    <Form.Label>
                      نام شرکت
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      {...register("compony", { required: true })}
                    />
                    {errors.compony?.type === "required" && (
                      <p>نام شرکت الزامی</p>
                    )}
                  </Col>

                  <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                    <Form.Label>
                      شناسه ملی شرکت
                      {senderOrgetter === 0 && (
                        <span className="text-danger">*</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="number"
                      {...register("companyCode", {
                        required: {
                          value: (() => {
                            if (senderOrgetter === 0) {
                              return true;
                            }
                            return false;
                          })(),
                        },
                      })}
                    />
                    {errors.companyCode?.type === "required" && (
                      <p>شناسه ملی شرکت الزامی</p>
                    )}
                  </Col>
                </Fragment>
              )}

              <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                <Form.Label>
                  تلفن همراه<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  {...register("phone", {
                    required: true,
                    minLength: 11,
                    maxLength: 11,
                    validate: {
                      format: v => {
                        if (v[0] !== "0" || v[1] !== "9") {
                          return false;
                        }

                        return true;
                      },
                    },
                  })}
                />
                {errors.phone?.type === "required" && <p>تلفن همراه الزامی</p>}
                {errors.phone?.type === "minLength" && <p>باید 11 رقم باشد</p>}
                {errors.phone?.type === "maxLength" && <p>باید 11 رقم باشد</p>}
                {errors.phone?.type === "format" && (
                  <p>تلفن همراه باید با 09 شروع شود</p>
                )}
              </Col>

              <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                <Form.Label>تلفن ثابت</Form.Label>
                <Form.Control type="number" {...register("tel")} />
              </Col>

              <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                <Form.Label>ایمیل</Form.Label>
                <Form.Control
                  type="text"
                  {...register("email", {
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "باید قالب ایمیل رعایت شود",
                    },
                  })}
                />
                {errors.email?.type === "pattern" && (
                  <p>{errors.email.message}</p>
                )}
              </Col>

              <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                <Form.Label>
                  استان<span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  {...register("provinceId", {
                    valueAsNumber: true,
                    min: 1,
                    onChange: e => {
                      getCities(parseInt(e.target.value));
                      setAreas(() => []);
                      setValue("cityId", 0);
                      if (senderOrgetter === 0) {
                        setValue("areaId", 0);
                      }
                    },
                  })}
                >
                  <option value={0}>هیچکدام</option>
                  {provinces.map(item => (
                    <option value={item.id} key={item.id}>
                      {item.faName}
                    </option>
                  ))}
                </Form.Select>
                {errors.provinceId?.type === "min" && (
                  <p>انتخاب استان الزامی</p>
                )}
              </Col>

              <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                <Form.Label>
                  شهر<span className="text-danger">*</span>
                </Form.Label>

                <Controller
                  control={control}
                  defaultValue={0}
                  rules={{ required: true, min: 1 }}
                  name="cityId"
                  render={({ field: { onChange, value, ref } }) => (
                    <Select
                      inputRef={ref}
                      classNamePrefix="dir-farsi "
                      options={cities}
                      value={cities.find(c => c.value === value)}
                      onChange={val => {
                        onChange(val.value);

                        if (senderOrgetter === 0) {
                          setValue("areaId", 0);
                          getArea(val.value);
                        }
                      }}
                    />
                  )}
                />
                {errors.cityId?.type === "min" && <p>انتخاب شهر الزامی</p>}
              </Col>

              {senderOrgetter === 0 && (
                <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                  <Form.Label>
                    <span>منطقه</span>
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    {...register("areaId", {
                      valueAsNumber: true,

                      min: {
                        value: (() => {
                          if (senderOrgetter === 0) {
                            if (areas.length > 0) {
                              return 1;
                            } else return 0;
                          }
                          return 0;
                        })(),
                        message: "انتخاب منطقه الزامی",
                      },
                    })}
                  >
                    <option value={0}>هیچکدام</option>
                    {areas.map(item => (
                      <option value={item.id} key={item.id}>
                        {item.faName}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.areaId?.type === "min" && (
                    <p>{errors.areaId.message}</p>
                  )}
                </Col>
              )}

              <Col xs={12} sm={6} lg={4} className="py-1 px-2">
                <Form.Label>
                  <span>کد پستی</span>
                  {senderOrgetter === 1 && (
                    <span className="text-danger">*</span>
                  )}
                </Form.Label>
                <Form.Control
                  type="number"
                  {...register(
                    "postCode",
                    senderOrgetter === 0
                      ? {
                          minLength: {
                            value: 10,
                            message: "کد پستی باید 10 رقم باشد",
                          },
                          maxLength: {
                            value: 10,
                            message: "کد پستی باید 10 رقم باشد",
                          },
                        }
                      : {
                          required: {
                            value: true,
                            message: "کد پستی الزامی",
                          },
                          minLength: {
                            value: 10,
                            message: "کد پستی باید 10 رقم باشد",
                          },
                          maxLength: {
                            value: 10,
                            message: "کد پستی باید 10 رقم باشد",
                          },
                        }
                  )}
                />
                {errors.postCode && <p>{errors.postCode.message}</p>}
              </Col>

              <Col xs={12} className="py-1 px-2">
                <Form.Label>
                  آدرس<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  {...register("address", { required: true, minLength: 5 })}
                />
                {errors.address?.type === "required" && <p>آدرس الزامی</p>}
                {errors.address?.type === "minLength" && <p>حداقل 5 حرف</p>}
              </Col>

              {senderOrgetter === 0 && (
                <Col
                  xs="12"
                  className="px-2 mt-2 d-flex align-items-center column-gap-2"
                >
                  <Form.Check
                    className={style.checkBox}
                    onChange={e => setForeignNationalCode(e.target.checked)}
                    id="e6@ra2zadR"
                    defaultValue={isForeignNationalCode}
                  />
                  <Form.Label
                    className="mb-0 c-pointer user-select-none"
                    htmlFor="e6@ra2zadR"
                  >
                    ثبت مرسوله برای اتباع
                  </Form.Label>
                </Col>
              )}

              {senderOrgetter === 0 && isForeignNationalCode && (
                <div className="mt-3 py-1 px-2">
                  <Col xs={12} lg={8}>
                    <Form.Label>
                      شناسه یکتا/کد شناسایی تبعه/کد فراگیر/کد فیدا:
                    </Form.Label>
                    <Form.Control
                      {...register("foreignNationalCode", {
                        required: {
                          value: senderOrgetter === 0 && isForeignNationalCode,
                          message: "کد اتباع الزامی",
                        },
                      })}
                    />
                  </Col>
                  {errors.foreignNationalCode && (
                    <p>{errors.foreignNationalCode.message}</p>
                  )}
                  <span>
                    توجه داشته باشید که مسئولیت ارسال مرسوله برای اتباع تماما
                    برعهده ثبت کننده مرسوله می‌باشد
                  </span>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-white">
            <Button
              variant="success"
              type="button"
              disabled={isLoading === true || loading === true}
              className="d-flex align-items-center"
              onClick={handleSubmit(doSubmit)}
            >
              {isLoading === true ? (
                <div className="d-flex align-items-center">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span className="me-1"> در حال ذخیره</span>
                </div>
              ) : (
                <span>ذخیره</span>
              )}
            </Button>
            <Button variant="danger" onClick={() => onClose(-1)}>
              بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
}
export default NewAddress;
